import actions from '../constants';
import errorAction from '../../errorAction';
import organizationRoot from '../../../utilities/organizationRoot';

export default gameId => async(dispatch, getState) => {
  dispatch({ type: actions.GET_START, payload: { gameId } });

  try {
    const snapshot = await organizationRoot(getState)
      .child('game-codings')
      .child(gameId)
      .once('value');
    return dispatch({
      type: actions.GET_FINISH,
      payload: { gameId, coding: snapshot.val() }
    });
  }
  catch (err) {
    return dispatch(errorAction(actions.GET_ERROR, err));
  }
};



// WEBPACK FOOTER //
// ./src/modules/coding/actions/getCodings.js